import { h } from 'preact';
import htm from 'htm';

const html = htm.bind(h);

export function Modals() {
    return html`
        <div id="group-modal" class="modal" style="display: none;">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 id="group-modal-title">Create New Group</h3>
                    <button class="modal-close" id="close-group-modal">${'\u00d7'}</button>
                </div>
                <form id="create-group-form">
                    <div class="form-group">
                        <label for="group-name">Group Name</label>
                        <input type="text" id="group-name" required placeholder="e.g., Book Club, Running Group" />
                    </div>
                    <div class="form-group">
                        <label for="group-description">Description (Optional)</label>
                        <textarea id="group-description" rows="3" placeholder="What is this group about?"></textarea>
                    </div>
                    <div class="form-group">
                        <label for="group-type">Group Type</label>
                        <select id="group-type">
                            <option value="open">Open - Anyone can join</option>
                            <option value="closed">Closed - Requires approval to join</option>
                        </select>
                        <small style="display: block; margin-top: 5px; color: var(--text-secondary);">
                            Open groups allow anyone to join. Closed groups require admin approval.
                        </small>
                    </div>
                    <div class="form-group">
                        <label for="group-zip">Location (ZIP Code)</label>
                        <input type="text" id="group-zip" placeholder="e.g., 90210" maxlength="10" />
                        <small style="display: block; margin-top: 5px; color: var(--text-secondary);">
                            Adding a location helps nearby people discover your group.
                        </small>
                    </div>
                    <div class="form-group" id="group-admins-section" style="display: none;">
                        <label for="group-admins">Admins (Email addresses, comma-separated)</label>
                        <input type="text" id="group-admins" placeholder="admin1@example.com, admin2@example.com" />
                        <small style="display: block; margin-top: 5px; color: var(--text-secondary);">
                            Admins can edit the group and manage members.
                        </small>
                    </div>
                    <div class="modal-actions">
                        <button type="button" class="btn btn-secondary" id="cancel-group-modal">Cancel</button>
                        <button type="submit" class="btn btn-primary" id="submit-group-btn">Create Group</button>
                    </div>
                </form>
            </div>
        </div>

        <div id="join-request-modal" class="modal" style="display: none;">
            <div class="modal-content">
                <div class="modal-header">
                    <h3>Request to Join Group</h3>
                    <button class="modal-close" id="close-join-request-modal">${'\u00d7'}</button>
                </div>
                <form id="join-request-form">
                    <div class="form-group">
                        <label for="join-message">Message to Admin (Optional)</label>
                        <textarea id="join-message" rows="3" placeholder="Hi, I'd like to join..."></textarea>
                    </div>
                    <div class="modal-actions">
                        <button type="button" class="btn btn-secondary" id="cancel-join-request-modal">Cancel</button>
                        <button type="submit" class="btn btn-primary" id="submit-join-request-btn">Send Request</button>
                    </div>
                </form>
            </div>
        </div>

        <div id="dialog-modal" class="modal" style="display: none;">
            <div class="modal-content" style="max-width: 400px;">
                <div class="modal-header">
                    <h3 id="dialog-title">Confirm</h3>
                    <button class="modal-close" id="close-dialog-modal">${'\u00d7'}</button>
                </div>
                <div style="padding: 20px;">
                    <p id="dialog-message" style="margin-bottom: 20px;"></p>
                    <div id="dialog-input-container" style="display: none; margin-bottom: 20px;">
                        <textarea
                            id="dialog-input"
                            rows="3"
                            style="width: 100%; padding: 10px; border: 1px solid var(--border); border-radius: 8px; font-family: inherit;"
                        ></textarea>
                    </div>
                    <div class="modal-actions">
                        <button type="button" class="btn btn-secondary" id="dialog-cancel-btn">Cancel</button>
                        <button type="button" class="btn btn-primary" id="dialog-confirm-btn">Confirm</button>
                    </div>
                </div>
            </div>
        </div>

        <div id="group-events-modal" class="modal" style="display: none;">
            <div class="modal-content" style="max-width: 600px;">
                <div class="modal-header">
                    <h3 id="group-events-title">Upcoming Events</h3>
                    <button class="modal-close" id="close-group-events-modal">${'\u00d7'}</button>
                </div>
                <div id="group-events-list" style="padding: 20px; max-height: 400px; overflow-y: auto;">
                    <div class="empty-state">Loading events...</div>
                </div>
            </div>
        </div>

        <div id="event-rsvps-modal" class="modal" style="display: none;">
            <div class="modal-content" style="max-width: 600px;">
                <div class="modal-header">
                    <h3 id="event-rsvps-title">Event RSVPs</h3>
                    <button class="modal-close" id="close-event-rsvps-modal">${'\u00d7'}</button>
                </div>
                <div id="event-rsvps-content" style="padding: 20px; max-height: 500px; overflow-y: auto;">
                    <div class="empty-state">Loading RSVPs...</div>
                </div>
            </div>
        </div>
    `;
}
